import Icon from "@ant-design/icons";

import { ReactComponent as GearSolid } from './gear-solid.svg';
import { ReactComponent as FileSignatureSolid } from './file-signature-solid.svg';
import { ReactComponent as BanSolid } from './ban-solid.svg';
import { ReactComponent as MapLocationDotSolid } from './map-location-dot-solid.svg';
import { ReactComponent as FilePdfSolid } from './file-pdf-solid.svg';
import { ReactComponent as ListSolid } from './list-solid.svg';
import { ReactComponent as EuroSignSolid } from './euro-sign-solid.svg';
import { ReactComponent as PeopleGroupSolid } from './people-group-solid.svg';
import { ReactComponent as HouseSolid } from './house-solid.svg';
import { ReactComponent as CircleUserSolid } from './circle-user-solid.svg';
import { ReactComponent as CashRegisterSolid } from './cash-register-solid.svg';
import { ReactComponent as BuildingSolid } from './building-solid.svg';
import { ReactComponent as HouseCircleExclamationSolid } from './house-circle-exclamation-solid.svg';
import { ReactComponent as LinkSolidFull } from './link-solid-full.svg';
import { ReactComponent as TableSolidFull } from './table-solid-full.svg';
import { ReactComponent as ListCheckSolidFull } from './list-check-solid-full.svg';
import { ReactComponent as CopySolidFull } from './copy-solid-full.svg';
import { ReactComponent as PersonDressSolidFull } from './person-dress-solid-full.svg';
import { ReactComponent as PersonSolidFull } from './person-solid-full.svg';
import { ReactComponent as PhoneSolidFull } from './phone-solid-full.svg';
import { ReactComponent as ChevronLeftSolidFull } from './chevron-left-solid-full.svg';
import { ReactComponent as PencilSolidFull } from './pencil-solid-full.svg';
import { ReactComponent as SmokingSolidFull } from './smoking-solid-full.svg';
import { ReactComponent as BanSmokingSolidFull } from './ban-smoking-solid-full.svg';
import { ReactComponent as CatSolidFull } from './cat-solid-full.svg';
import { ReactComponent as DogSolidFull } from './dog-solid-full.svg';
import { ReactComponent as OpensuseBrandsSolidFull } from './opensuse-brands-solid-full.svg';
import { ReactComponent as AngleDownSolidFull } from './angle-down-solid-full.svg';
import { ReactComponent as AngleUpSolidFull } from './angle-up-solid-full.svg';
import { ReactComponent as CircleRegularFull } from './circle-regular-full.svg';

export const IconGearSolid = () => <Icon component={GearSolid} />;
export const IconFileSignatureSolid = () => <Icon component={FileSignatureSolid} />;
export const IconBanSolid = () => <Icon component={BanSolid} />;
export const IconMapLocationDotSolid = () => <Icon component={MapLocationDotSolid} />;
export const IconFilePdfSolid = () => <Icon component={FilePdfSolid} />;
export const IconListSolid = () => <Icon component={ListSolid} />;
export const IconEuroSignSolid = () => <Icon component={EuroSignSolid} />;
export const IconPeopleGroupSolid = () => <Icon component={PeopleGroupSolid} />;
export const IconHouseSolid = () => <Icon component={HouseSolid} />;
export const IconCircleUserSolid = () => <Icon component={CircleUserSolid} />;
export const IconCashRegisterSolid = () => <Icon component={CashRegisterSolid} />;
export const IconBuildingSolid = () => <Icon component={BuildingSolid} />;
export const IconHouseCircleExclamationSolid = () => <Icon component={HouseCircleExclamationSolid} />;
export const IconLinkSolidFull = () => <Icon component={LinkSolidFull} />;
export const IconTableSolidFull = () => <Icon component={TableSolidFull} />;
export const IconListCheckSolidFull = () => <Icon component={ListCheckSolidFull} />;
export const IconCopySolidFull = () => <Icon component={CopySolidFull} />;
export const IconPersonDressSolidFull = () => <Icon component={PersonDressSolidFull} />;
export const IconPersonSolidFull = () => <Icon component={PersonSolidFull} />;
export const IconPhoneSolidFull = () => <Icon component={PhoneSolidFull} />;
export const IconChevronLeftSolidFull = () => <Icon component={ChevronLeftSolidFull} />;
export const IconPencilSolidFull = () => <Icon component={PencilSolidFull} />;
export const IconSmokingSolidFull = () => <Icon component={SmokingSolidFull} />;
export const IconBanSmokingSolidFull = () => <Icon component={BanSmokingSolidFull} />;
export const IconCatSolidFull = () => <Icon component={CatSolidFull} />;
export const IconDogSolidFull = () => <Icon component={DogSolidFull} />;
export const IconOpensuseBrandsSolidFull = () => <Icon component={OpensuseBrandsSolidFull} />;
export const IconAngleDownSolidFull = () => <Icon component={AngleDownSolidFull} />;
export const IconAngleUpSolidFull = () => <Icon component={AngleUpSolidFull} />;
export const IconCircleRegularFull = () => <Icon component={CircleRegularFull} />;